import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { modalRootEl } from '../../constants';
import { ModalInterface } from './modal.interface';
import styles from './modal.module.css';

const Modal: React.FunctionComponent<ModalInterface> = ({
  onClose,
  children,
}) => {
  const [mountNode] = useState(document.createElement('div'));

  const handleClose = () => {
    const cssTransitionDuration = getComputedStyle(mountNode).getPropertyValue('--transition-duration');
    mountNode.classList.remove(styles.isOpened);

    setTimeout(onClose, parseInt(cssTransitionDuration, 10));
  };

  useEffect(() => {
    const lastOverflow = document.body.style.overflow;

    document.body.style.overflow = 'hidden';
    mountNode.classList.add(styles.component);
    modalRootEl?.appendChild(mountNode);
    setTimeout(() => mountNode.classList.add(styles.isOpened), 0);

    return () => {
      modalRootEl?.removeChild(mountNode);
      document.body.style.overflow = lastOverflow;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const wrap = (
    <div
      className={styles.content}
    >
      <div onClick={handleClose} className={styles.close}></div>

      {children}
    </div>
  );

  return (
    ReactDOM.createPortal(
      wrap,
      mountNode,
    )
  );
};

export default Modal;
